<template>
  <v-row justify="center" class="my-0 py-4">
    <v-col cols="11" class="white rounded-xl">
      <v-tabs :color="color.primaryVariant" v-model="tab">
        <v-tab v-if="!isAsofomBranch">
          <span class="wc-caption-1">Administrar Membresías</span>
        </v-tab>
        <v-tab>
          <span class="wc-caption-1">Miembros</span>
        </v-tab>
        <v-tab v-if="user.role == 'HEAD_OFFICE' || isAmpiFullAccess">
          <span class="wc-caption-1">Formulario de Registro</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-if="!isAsofomBranch">
          <Affiliations></Affiliations>
        </v-tab-item>

        <v-tab-item>
          <Members></Members>
        </v-tab-item>

        <v-tab-item v-if="user.role == 'HEAD_OFFICE' || isAmpiFullAccess">
          <Registration></Registration>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import Chat from '@/components/shared/Chat.vue';

import { colors } from '@/constants/colors';
import Affiliations from '../Affiliations.vue';
import Members from '../Members/index.vue';
import Registration from '../Registration.vue';
import { mapState } from 'vuex';
import { isOrganization } from '../../../share/validateOrganization';
import { isAmpiOrganizationUser } from '@/common/ampiOrganizationUserAccess';

export default {
  name: 'MyMembers',
  components: {
    Members,
    Affiliations,
    Registration,
    Chat,
  },
  data() {
    return {
      color: colors,
      tab: null,
    };
  },
  computed: {
    ...mapState('user', ['user']),
    isAmpiFullAccess() {
      return isAmpiOrganizationUser(this.user);
    },
    isAsofomBranch() {
      const isBranch = this.user.role === 'BRANCH';
      return (
        isOrganization('asofom', this.user?._id, this.user?.headOffice?._id) &&
        isBranch
      );
    },
  },
  methods: {
    isOrganization,
  },
};
</script>

<style></style>
